import fetch from "auth/FetchInterceptor";
import { useDispatch } from "react-redux";
import { signOut } from "redux/actions/Auth";

const JwtAuthService = {};

JwtAuthService.refreshToken = function () {
  return fetch({
    url: "/token/refresh",
    method: "Get",
  })
}

JwtAuthService.login = function (data) {
  return fetch({
    url: "/login_check",
    method: "post",
    data: data,
  });
};

JwtAuthService.signOut = function () {
  return fetch({
    url: "/user/logout",
    method: "Get",
  });
};

JwtAuthService.signUp = function (data) {
  return fetch({
    url: "/user/signup",
    method: "post",
    data: data,
  });
};

export default JwtAuthService;
